// import Vue from 'vue'
import scroll from './v-scroll'
Vue.directive('scroll', scroll)

import imgerr from './imgerr.js'
Vue.directive('imgerr', imgerr)


// WEBPACK FOOTER //
// ./src/directive/index.js